import { IDocTransformer } from '../../interfaces/transformer/type';
import { injectable } from 'inversify';
import { factory } from '../../ConfigLog4j';
import { IMatterDoc, IAddFolder } from '../../types';
import { T360AdapterAddFolderActionableEntity } from '../actionableEntity/addFolderActionableEntity';
import { IDocOperationInvocation } from '../../interfaces/urlPattern/types';
import { IAddFolder_T360 } from '../types';

const log = factory.getLogger('T360AdapterAddFolderEntityTransformer');

@injectable()
export class T360AdapterAddFolderEntityTransformer implements IDocTransformer {
    transformIntoActionableEntity(
        nodeObj: IAddFolder,
        _matterDoc: IMatterDoc,
        _urlPattern: IDocOperationInvocation,
    ): T360AdapterAddFolderActionableEntity {
        log.debug('Calling transformIntoActionableEntity');
        const obj = {} as T360AdapterAddFolderActionableEntity;
        // TO CREATE ACTIONABLE ENTITY FROM nodeObj and matterDoc

        const nodeObj1 = nodeObj as IAddFolder_T360;
        if (nodeObj1.name !== undefined || nodeObj1.name) {
            obj.name = nodeObj1.name;
        }

        if (nodeObj1.editAccessType !== undefined || nodeObj1.editAccessType) {
            obj.editAccessType = nodeObj1.editAccessType;
        }

        if (nodeObj1.viewAccessType !== undefined || nodeObj1.viewAccessType) {
            obj.viewAccessType = nodeObj1.viewAccessType;
        }
        if (nodeObj1?.viewMembers) {
            obj.viewMembers = nodeObj1.viewMembers;
        }
        if (nodeObj1?.editMembers) {
            obj.editMembers = nodeObj1.editMembers;
        }
        if (nodeObj1.extendedProps?.admittedMembers) {
            obj.admittedMembers = nodeObj1.extendedProps?.admittedMembers;
        }

        return obj;
    }
}
